var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgThreeDotsHollow = function SvgThreeDotsHollow(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 5,
    viewBox: "0 0 15 5",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6938 4C13.5058 4 14.164 3.32843 14.164 2.5C14.164 1.67157 13.5058 1 12.6938 1C11.8819 1 11.2236 1.67157 11.2236 2.5C11.2236 3.32843 11.8819 4 12.6938 4Z",
    stroke: "#949494",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79294 4C8.6049 4 9.26313 3.32843 9.26313 2.5C9.26313 1.67157 8.6049 1 7.79294 1C6.98098 1 6.32275 1.67157 6.32275 2.5C6.32275 3.32843 6.98098 4 7.79294 4Z",
    stroke: "#949494",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89255 4C3.70451 4 4.36274 3.32843 4.36274 2.5C4.36274 1.67157 3.70451 1 2.89255 1C2.08059 1 1.42236 1.67157 1.42236 2.5C1.42236 3.32843 2.08059 4 2.89255 4Z",
    stroke: "#949494",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgThreeDotsHollow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/three-dots-hollow.4c6345286fd36588d0dcfa124188d82f.svg";